import React from 'react';
import type { ReactNode } from 'react';
import classNames from 'classnames';
import { getIconByName } from './shared_icons/AppIcons';
import actionButtonStyles from '../../../stylesheets/management_site/actionButton.module.scss';

interface ActionButtonProps {
  onClick: (event: React.MouseEvent<HTMLButtonElement>) => void;
  iconName?: string;
  icon?: ReactNode;
  text: string;
  className?: string;
  textClassName?: string;
  iconPosition?: 'left' | 'right';
  buttonProps?: React.ButtonHTMLAttributes<HTMLButtonElement> & {
    'data-test-class'?: string;
    'data-title'?: string;
  };
}

const ActionButton = ({
  onClick,
  iconName,
  icon,
  text,
  className,
  textClassName,
  iconPosition = 'left',
  buttonProps,
}: ActionButtonProps) => {
  const { className: buttonClassName, ...restButtonProps } = buttonProps || {};

  return (
    <button
      type="button"
      onClick={onClick}
      className={classNames(
        'mdc-button',
        'mdc-button--bordered',
        actionButtonStyles.actionButton,
        {
          [actionButtonStyles.textButton]: text,
          [actionButtonStyles.textOnlyButton]: text && !iconName && !icon,
          [actionButtonStyles.iconRight]: iconPosition === 'right',
        },
        className,
        buttonClassName
      )}
      data-test-class={
        text
          ? `action-button-${text.toLowerCase().replace(/\s+/g, '-')}`
          : `action-button-${iconName}`
      }
      {...restButtonProps}
    >
      {iconPosition === 'left' &&
        (icon ?? (iconName && getIconByName(iconName)))}
      {text && <span className={textClassName}>{text}</span>}
      {iconPosition === 'right' &&
        (icon ?? (iconName && getIconByName(iconName)))}
    </button>
  );
};

export default ActionButton;
